const ONE_TRUST_COOKIE_NAME = "OptanonConsent";

export type OneTrustCookieStatus = {
  oneTrustConfigured: boolean;
  cookieAvailable: boolean;
  shouldLoadOneTrustScript: boolean;
  shouldUseConsentGating: boolean;
  shouldFallbackOptIn: boolean;
  shouldReportMissingCookie: boolean;
};

export function hasOneTrustConsentCookie(cookieString = ""): boolean {
  return cookieString
    .split(";")
    .some((cookie) =>
      cookie.trim().startsWith(`${ONE_TRUST_COOKIE_NAME}=`),
    );
}

export function resolveOneTrustCookieStatus(
  domainScript: string | undefined,
  cookieString = "",
): OneTrustCookieStatus {
  const oneTrustConfigured = Boolean(domainScript);
  const cookieAvailable =
    oneTrustConfigured && hasOneTrustConsentCookie(cookieString);
  const shouldUseConsentGating = oneTrustConfigured && cookieAvailable;

  return {
    oneTrustConfigured,
    cookieAvailable,
    shouldLoadOneTrustScript: shouldUseConsentGating,
    shouldUseConsentGating,
    shouldFallbackOptIn: !shouldUseConsentGating,
    shouldReportMissingCookie: oneTrustConfigured && !cookieAvailable,
  };
}

export function resolveBrowserOneTrustCookieStatus(
  domainScript: string | undefined,
): OneTrustCookieStatus {
  return resolveOneTrustCookieStatus(
    domainScript,
    typeof document === "undefined" ? "" : document.cookie,
  );
}
